import { Box, Paper, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  blackColor,
  blackShade19,
  greenColorM01,
  redColor11,
  whiteColor,
  yellowShade04,
} from "../../../configs/styles/muiThemes";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

// Y-Axis Formatter for Thousands (K)
const formatYAxis = (value) => {
  if (value >= 1000) {
    return `${(value / 1000).toFixed(1)}K`; // Converts to K format
  }
  return value;
};

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <Paper
        elevation={3}
        sx={{ p: "3px 6px", borderRadius: 1, bgcolor: whiteColor }}
      >
        <Typography
          sx={{
            fontSize: 11,
            fontWeight: 500,
            color: blackShade19,
            lineHeight: 1.5,
          }}
        >
          {label}
        </Typography>
        <Box>
          <Typography
            sx={{
              fontSize: 11,
              fontWeight: 400,
              color: blackShade19,
              lineHeight: 1.5,
            }}
          >
            Orders: {payload[0].payload.orderCount}
          </Typography>
        </Box>
      </Paper>
    );
  }
  return null;
};

const colors = [yellowShade04, greenColorM01];

function OrderChartSection({ chartData }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    const processedData = chartData?.map((item) => ({
      month: item?.month,
      orderCount: item?.orderCount ? parseInt(item.orderCount) : 0,
    }));
    setData(processedData);
  }, [chartData]);

  return (
    <Stack
      sx={{
        border: "1px solid #E1E8F0",
        borderRadius: "10px",
        backgroundColor: whiteColor,
        p: "10px 15px",
        gap: 1,
      }}
    >
      <Typography
        fontSize={13.5}
        fontWeight={600}
        color={blackShade19}
        lineHeight="20px"
      >
        Order Analysis
      </Typography>

      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={data}
          margin={{ top: 20, right: 30, left: 0, bottom: 0 }}
        >
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis
            dataKey="month"
            tick={{
              fill: blackShade19,
              fontSize: 11,
              fontWeight: 500,
            }}
            interval={0}
            // tickFormatter={(month) => month.substring(0, 3)} // Jan, Feb, etc.
            tickFormatter={(value) => {
              const parts = value.split("-");
              // return parts.length === 3 ? value : `${parts[0]}-${parts[1]}`;
               return parts.length === 3
                 ? `${parts[0]}`
                //  : `${parts[0]}-${parts[1]}`;
                 : `${parts[0]}`;
            }}
            axisLine={{ stroke: "#000" }}
            tickLine={false}
          />
          <YAxis
            tick={{
              fill: blackShade19,
              fontSize: 11,
              fontWeight: 500,
            }}
            tickFormatter={formatYAxis}
            axisLine={{ stroke: "#000" }}
            tickLine={false}
            // domain={[0, "dataMax + 50"]}
          />
          <Tooltip
            content={<CustomTooltip />}
            cursor={{ fill: "transparent" }}
          />

          <Bar dataKey="orderCount" barSize={10} radius={[10, 10, 0, 0]}>
            {data?.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={colors[index % colors.length]}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Stack>
  );
}

export default OrderChartSection;
